class FeaturedBrands extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.isAnimating = false; // Flag to check if an animation is in progress

    this.brands = this.querySelectorAll(".featured-brand-card");

    this.btnPrev = this.querySelector("#btn-prev-brand");
    this.btnNext = this.querySelector("#btn-next-brand");

    this.onPrevClick = this.prevBrand.bind(this);
    this.onNextClick = this.nextBrand.bind(this);

    if (this.btnPrev) {
      this.btnPrev.addEventListener("click", this.onPrevClick);
    }

    if (this.btnNext) {
      this.btnNext.addEventListener("click", this.onNextClick);
    }
  }

  prevBrand(evt) {
    console.log("prevBrand");
    this.currentIndex = this.currentIndex - 1;
    if (this.currentIndex <= 0) {
      this.currentIndex = 0;
    }
    this.changeActiveBrand();
  }

  nextBrand(evt) {
    console.log("nextBrand");
    this.currentIndex = this.currentIndex + 1;
    if (this.currentIndex >= this.brands.length) {
      this.currentIndex = 0;
    }
    this.changeActiveBrand();
  }

  changeActiveBrand() {
    const container = document.getElementById("featured-brands-slider");
    const collection = this.brands[this.currentIndex];

    const containerRect = container.getBoundingClientRect();
    const collectionRect = collection.getBoundingClientRect();

    const scrollLeft =
      container.scrollLeft + (collectionRect.left - containerRect.left);

    if (!this.isAnimating) {
      this.isAnimating = true;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });

      setTimeout(() => {
        this.isAnimating = false;

        // Toggle visibility of btnPrev after the scrolling animation
        if (this.currentIndex > 0) {
          this.btnPrev.classList.add("btn-visible");
          this.btnPrev.classList.remove("btn-invisible");
        } else {
          this.btnPrev.classList.add("btn-invisible");
          this.btnPrev.classList.remove("btn-visible");
        }
      }, 550); // Assuming the smooth scroll takes around 500ms, so we delay by slightly more
    }

    // Listen for the scroll event on the container
    if (this.scrollListener) {
      container.removeEventListener("scroll", this.scrollListener);
    }

    this.scrollListener = container.addEventListener("scroll", () => {
      // hide btnNext if we have scrolled to the end of the container, toggle class name 'visible'
      const containerWidth = container.offsetWidth;
      const collectionWidth = collection.offsetWidth;
      const distanceToEnd =
        containerWidth -
        (collectionRect.left + collectionWidth - containerRect.left);
      const scrolledAmount = container.scrollLeft;
      if (
        scrolledAmount + containerWidth + distanceToEnd >=
        container.scrollWidth
      ) {
        this.btnNext.classList.add("btn-invisible");
        this.btnNext.classList.remove("btn-visible");
      } else {
        this.btnNext.classList.add("btn-visible");
        this.btnNext.classList.remove("btn-invisible");
      }

      // show btnNext if we have not scrolled to the end of the container, toggle class name 'visible'
      if (scrolledAmount + containerWidth < container.scrollWidth) {
        this.btnNext.classList.add("btn-visible");
        this.btnNext.classList.remove("btn-invisible");
      }
    });
  }
}

customElements.define("featured-brands", FeaturedBrands);
